import { Col } from 'ia-react-core';
import styled, { css } from 'styled-components';

export const StyledNotification = styled.a`
  display: flex;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  outline: none;
  text-decoration: none;

  &.unvisited {
    background-color: ${({ theme }) => theme.colors.blue12};
    font-weight: 600;

    &:hover {
      background-color: ${({ theme }) => theme.colors.blue14};
    }

    &:focus {
      background-color: ${({ theme }) => theme.colors.blue14};
    }
  
    &:active {
      background-color: ${({ theme }) => theme.colors.blue15};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue12};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.blue12};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.blue14};
  }
`;

export const StyledLink = styled.div`
  display: contents;
  text-decoration: none;
  height: 100%;
`;

export const StyledLobIcon = styled.div`
  padding: 0 16px;
  width: 36px;
  margin: auto;
  color: ${({ theme }) => theme.colors.blue6};
`;

export const StyledLobDiv = styled.div<{ withType: boolean }>`
  position: relative;
  z-index: 9;
  top: 3px;

  ${({ withType }) => withType && css`
    top: -11px;
  `}
`;

export const StyledNotificationText = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black};
  margin: 0rem 0.25rem 0rem;
  font-weight: 600;
  &.unvisited {
    font-weight: bold;
  }
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  box-orient: vertical;
  -webkit-box-orient: vertical;
`;

export const StyledTime = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: normal;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray6};
  margin: 0.25rem 1.75rem 0 0.25rem;

  &.unvisited {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const StyledNotificationTextSection = styled.div`
  width: 90%;
`;

export const StyledLeftCol = styled(Col)`
  padding: 15px 0px 10px;
`;

export const StyledRightCol = styled(Col)`
  width: 100%;
  margin: auto;
`;
